export enum buttonVariants {
  WHITE = "white",
  DARKGRAY = "darkGray",
  GRAY = "gray",
  HOLLOW = "hollow",
  BRIGHTWHITE = "brightWhite",
  HOLLOWGRAY = "hollowGray",
  HOLLOWLIGHTGRAY = "hollowLightGray",
}
